import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Link from 'next/link';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { ITop100Authors } from '@/interfaces/top100Authors.interface';
import { getAuthorFullName } from '@/helpers/helpers';
import styles from '../top-searched/TopSearched.module.scss';

interface ITopAuthorsPage extends IWidgetsSideBar {
  topData: ITop100Authors;
}

const TopAuthors: FC<ITopAuthorsPage> = ({ topData, todayWidget, popularBooksWidget }) => {
  //seo block
  const SEO_TITLE = 'Топ 100 авторов за все время:: Электронная библиотека bookZ.ru';
  const SEO_DESCRIPTION = 'Рейтинг 100 самых популярных авторов за все время:: BookZ.ru';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref="/top100_authors" breadcrumbs={<Breadcrumbs firstPageName="Топ 100 популярных авторов" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <SectionTitle name="Топ 100 популярных авторов" />

      <ul className={styles.topList}>
        {topData.data.map((item, i) => (
          <li className={styles.topList__item} key={`${item.id}-${i}`}>
            <Link prefetch={false} href={`/authors/${item.alias}`} className={styles.topList__link}>
              {++i}. {getAuthorFullName(item.first_name, item.middle_name, item.last_name)}
            </Link>
            <span className={`${styles.topList__count} ${styles.topList__count_views}`}>{item.views_count}</span>
          </li>
        ))}
      </ul>
    </Layout>
  );
};
export default TopAuthors;
